// @flow
import React from "react";
import RowLetter from "./styled-components";

type Props = {
  /**
   * letter of the separator
   */
  letter: string
};

const TrackSplitter = ({ letter }: Props) => <RowLetter>{letter}</RowLetter>;

TrackSplitter.defaultProps = {
  letter: ""
};

// $FlowFixMe
export default React.memo(TrackSplitter);
